import { KatDivider, KatBadge } from '@amzn/katal-react';
import React from 'react';
import { isFormHeaderField } from '../rjsf/Utils';
import { isEmpty } from 'lodash';
import { useTranslation } from 'react-i18next';

export let CustomObjectFieldTemplate: (
    { TitleField, properties, title, description, idSchema, schema }:
    { TitleField: any, properties: any, title: any, description: any, idSchema: any, schema: any }
) => any;

CustomObjectFieldTemplate = ({TitleField, properties, title, description, idSchema, schema}) => {
    return (
        <div className="custom_object_field_template">
            {generateObjectHeader(title, idSchema)}
            <div className="row">
                {
                    properties.map((prop: any) => (
                        <div className="col-lg-2 col-md-4 col-sm-6 col-xs-12" key={prop.content.key}>
                                {customizeContentFragment(prop.content.key, prop.content)}
                        </div> ))
                }
            </div>
            { generateObjectFooter(properties, title, description, idSchema) }
        </div>
    );
};

/**
 * In case of anyOf Object Arrays, the widgets do not receive all props.
 * One of the important props is 'disabled' flag.
 *
 * If you need to pass options to your custom widget, you can add a ui:options object containing those properties.
 * If the widget has defaultProps, the options will be merged with the (optional) options object from defaultProps
 *
 * @param key {string} key of the content
 * @param content {any} React component.
 */

const customizeContentFragment = (key: string, content: any) => {
    if ( content.props.schema.anyOf ) {

        let existingUiOptions = content.props.uiSchema['ui:options'];
        if (isEmpty(existingUiOptions)) {
            existingUiOptions = {};
        }

        let updatedOptions = content.props.schema.anyOf.map((op: any, index: number) => {
            const { title } = op;
            // const _value = value.toString();
            return {
                label: title,
                value: index.toString()
            };
        });

        let new_options = {enumOptions: updatedOptions}
        content.props.uiSchema['ui:options'] = {
            ...existingUiOptions,
            value: Number(getIndex(updatedOptions, content.props.formData)),
            disabled: content.props.disabled,
            options: new_options
        };
    }

    return (
        <React.Fragment>
            {content}
        </React.Fragment>
    )
};


const generateObjectHeader = (title: any, idSchema: any) => {
    if (isFormHeaderField(idSchema.$id)) {
      // This is the form header.
      return (
          <React.Fragment>
              <h3 className="remove-left-pad">
                  {title} &nbsp;
              </h3>
              <KatDivider variant="athens"/>
          </React.Fragment>
      );
  } else {
      // This is not form header but internal Object header.
      if (title) {
          return (
              <div>
                  <p />
                  <KatBadge type="info" label={title} />
                  <p />
              </div>
          );
      } else {
          return null;
      }
  }
};

const generateObjectFooter = (properties: any, title: any, description: any, idSchema: any) => {
    if (isFormHeaderField(idSchema.$id)) {
        // This is the form header.
        return (
            <p />
        );
    } else {
        // This is not form header but internal Object header.
        return (
            <React.Fragment/>
        );
    }
};

const getIndex = (options: any, formData: any) => {
    let res : any;
    options.map((op: any) => {
        if (op.label === formData.declarationClaim) {
            res = op.value;
        }
      })
    return res;
};
